export type CaptainRole = 'pacer' | 'sweeper' | 'lead'

export const ROLE_LABEL: Record<CaptainRole, string> = {
  pacer: 'Pacer',
  sweeper: 'Sweeper',
  lead: 'Lead',
}

export interface RoleSlot {
  role: CaptainRole
  /**
   * ON-334: minimum captain headcount the organizer wants for this role.
   * Not a hard cap — sign-ups are accepted beyond this number (unlimited
   * overflow). Overflow = max(filledBy.length - target, 0).
   */
  target: number
  filledBy: string[]
}

export interface CaptainEvent {
  id: string
  name: string
  date: string
  location: string
  needsCaptains: boolean
  slots: RoleSlot[]
}

export interface ClubInfo {
  id: string
  slug: string
  name: string
}

export type PortalRole = 'guest' | 'captain' | 'organizer'
